module.exports = __webpack_public_path__ + "static/media/aws.1ff16d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/aws.png
// module id = 1491
// module chunks = 0